import devicePlugin from '@blazar-plugins/device'

export const screenTypeSelector = (state) => ({
  screenType: devicePlugin.selectors.screenType(state),
})

export default screenTypeSelector
